<button
  type="button"
  class="d-none btn btn-danger mb-2"
  (click)="toggleJsonStructure = !toggleJsonStructure"
>
  Toggle JSON
</button>
@if (!doesConditionalLogicExist) {
  <div class="d-flex align-items-center justify-content-center">
    <h5>
      Go to the <strong>Logic Builder</strong> and build the logic to see a
      working preview
    </h5>
  </div>
}
@if (dataToPreview && doesConditionalLogicExist) {
  <!-- FORM TITLE HEADER -->
  @if (previewModeFlag || mode === 'supplierEdit') {
    <div class="row mb-3">
      <div class="col-12">
        <span class="fs-5 fw-bold">Form Preview - {{ formTitle }}</span>
        <hr class="mt-2 mb-0" />
      </div>
    </div>
  }
  <!-- LEFT PANEL and QN PREVIEW -->
  <div class="row h-100 w-100 overflow-hidden">
    <div
      class="col-3"
      [ngClass]="
        previewModeFlag || mode === 'supplierEdit'
          ? 'management-li-preview'
          : 'editor-li-preview'
      "
    >
      <ul class="list-group overflow-auto">
        <!-- List of non submitter questions -->
        @if (doesValidNonSubmitterDataExist) {
          @for (qnObj of dataToPreview.nonSubmitterData; track qnObj) {
            <li
              [scrollItemIntoView]="qnObj.data[0].QuestionId"
              class="list-group-item cursor-pointer"
              [class.bg-secondary-subtle]="
                qnObj.data[0].QuestionId.trim() ===
                  currentlyPreviewedQuestion?.data[0]?.QuestionId?.trim() &&
                !renderSubmitterPreview
              "
              (click)="preview(qnObj)"
            >
              @if (!(qnObj | doesHiddenInputExist)) {
                <i
                  [class]="
                    (
                      ''
                      | getValidationIcon
                        : qnObj.answered
                        : qnObj.valid
                        : qnObj.data[1]?.isDisableInputChecked
                    ).faIconClass
                  "
                  [title]="
                    (
                      ''
                      | getValidationIcon
                        : qnObj.answered
                        : qnObj.valid
                        : qnObj.data[1]?.isDisableInputChecked
                    ).tooltip
                  "
                ></i>
              }
              &nbsp;&nbsp;{{ qnObj.data[0].dispalyFCText.trim() }}
            </li>
          }
        }
        <!-- Submitter question -->
        @if (doesValidSubmitterDataExist) {
          @if (doesValidSubmitterDataExist) {
            <li
              class="list-group-item"
              (click)="previewSubmitter()"
              [class.active]="renderSubmitterPreview"
            >
              <i
                class="fa"
                [ngClass]="{
                  'fa-exclamation-circle text-warning':
                    !isSubmitterSectionAnswered,
                  'fa-check-circle text-success': isSubmitterSectionAnswered,
                }"
              ></i
              >&nbsp;&nbsp;Submitter
            </li>
          }
        }
      </ul>
    </div>
    <div
      [ngClass]="[
        previewModeFlag || mode === 'supplierEdit'
          ? 'management-qn-preview'
          : 'editor-qn-preview',
        toggleJsonStructure ? 'col-5' : 'col-9',
      ]"
    >
      <!-- RENDER NON SUBMITTER QUESTIONS PREVIEW -->
      @if (!renderSubmitterPreview) {
        @for (field of currentlyPreviewedQuestion.data; track field) {
          @if (field.TypeValue=="Attachment" && mode === 'previewDisabled'){

            <a style="padding-left: 9px;" id="downloadLink" (click)="downloadFormQuestionAttachment(currentlyPreviewedQuestion.nodeLogic.id,currentlyPreviewedQuestion.nodeLogic.selectedAnswers[0])"> 
        {{currentlyPreviewedQuestion.nodeLogic.selectedAnswers[0]}} <i class="fa-solid fa-download"></i>
      </a>
          }
          @else{
            <div
            class="row p-2"
            listenClick
            [innerHTML]="
              replacePlaceholdersInText(field.question.changingThisBreaksApplicationSecurity)
                | safeHtml
                | evalScript
            "
          ></div>
          @if (field.TypeValue=="Attachment" && mode != 'previewDisabled' && currentlyPreviewedQuestion.nodeLogic.selectedAnswers[0]){
           <span style="padding-left: 9px;">{{currentlyPreviewedQuestion.nodeLogic.selectedAnswers[0]}}  <a (click)="removeFormQuestionAttachment(currentlyPreviewedQuestion.nodeLogic.id,currentlyPreviewedQuestion.nodeLogic.selectedAnswers[0])"><i class="fa fa-remove"></i></a></span> 
          }
          }
        }
      }
      <!-- RENDER SUBMITTER QUESTION PREVIEW -->
      @if (renderSubmitterPreview) {       
        
          @for (
            submitterQnObj of dataToPreview.submitterData;
            track submitterQnObj
          ) {
            <div class="row mb-3" [id]="submitterQnObj.sectionId">
              <div class="col-4">
                <div
                class="row col-sm-6__col-md-5__col-lg-4__col-xl-3"
                listenClick
                [innerHTML]="
                  replacePlaceholdersInText(submitterQnObj.data[0].questionlabel
                    .changingThisBreaksApplicationSecurity)
                    | safeHtml
                    | evalScript
                "
              ></div>
                <br />
                <input
                  type="text"
                  listenClick
                  [name]="submitterQnObj.data[0].dispalyFCText"
                  [id]="
                    'submitter__textboxID_' + submitterQnObj.data[0].QuestionId
                  "
                  [(ngModel)]="submitterQnObj.nodeLogic.selectedAnswers[0]" 
                  [disabled]="mode === 'previewDisabled'"                 
                />
              </div>
            </div>
          }
        
      }
    </div>
    <!-- DEBUG THE JSON OBJECT FOR THE CURRENT PREVIEW -->
    @if (toggleJsonStructure) {
      <div
        [ngClass]="
          previewModeFlag || mode === 'supplierEdit'
            ? 'management-li-preview'
            : 'editor-li-preview'
        "
        [class.col-4]="toggleJsonStructure"
      >
        @if (!renderSubmitterPreview) {
          <pre>{{ currentlyPreviewedQuestion | json }}</pre>
        }
        @if (renderSubmitterPreview) {
          <pre>{{ dataToPreview.submitterData | json }}</pre>
        }
      </div>
    }
  </div>
  <!-- FOOTER -->
  <div class="row mt-2">
    <div class="d-flex align-items-center justify-content-between">
      <!-- LEGENDS -->
      <div class="d-flex align-items-center justify-content-start me-auto">
        <div class="d-flex flex-column">
          @for (label of labels; track label) {
            <div
              class="d-flex flex-row align-items-center justify-content-start"
            >
              <i [class]="label.faIconClass"></i>&nbsp;&nbsp;
              <span class="">{{ label.infoText }}</span>
            </div>
          }
        </div>
      </div>
      <!-- INFO -->
      @if (
        currentlyPreviewedQuestion?.isLastNonSubmitterItem &&
        !renderSubmitterPreview
      ) {
        <span class="text-primary my-2">
          <i class="fa fa-info-circle"></i>&nbsp; Please use the left navigation
          panel to continue to fill submitter details.
        </span>
      }
      @if (
        previewModeFlag &&
        mode === "supplierEdit" &&
        renderSubmitterPreview &&
        !enableSubmitButton
      ) {
        <span class="text-primary my-2">
          <i class="fa fa-info-circle"></i>&nbsp; Submit button will be enabled
          once all the questions are answered and form saved successfully by
          clicking the save button.
        </span>
      }
      <!-- BUTTONS -->
      @if (isViewReady && enableNavigation && isMgmtPreview) {
        <div class="d-flex align-items-center justify-content-end ms-auto">
          <!-- COMMON QUESTION BUTTONS -->
          @if (previewModeFlag && mode === "supplierEdit") {
            <!-- SUPPLIER: EXIT BUTTON -->
            <button
              type="button"
              class="btn btn-outline-primary ms-2"
              (click)="exit()"
            >
              Exit
            </button>
            <!-- SUPPLIER: SAVE BUTTON -->
            @if (!isParentShared) {
              <button
                type="button"
                class="btn btn-primary ms-2"
                (click)="save()"
              >
                Save
              </button>
            }
          }
          <!-- BUTTONS FOR SUBMITTER QUESTION -->
          @if (renderSubmitterPreview) {
            <!-- BUYER MANAGEMENT PREVIEW -->
            @if (previewModeFlag && (mode !== "supplierEdit" && mode !== "previewDisabled") && formType !== "None") {
              <!-- GET SCORES BUTTON -->
              <button
                type="button"
                class="btn btn-primary ms-2"
                (click)="getScores()"
              >
                Get scores
              </button>
            }
            <!-- SUPPLIER PREVIEW -->
            @if (previewModeFlag && mode === "supplierEdit") {
              <!-- SUPPLIER: VALIDATE BUTTON -->
              <button
                type="button"
                class="d-none btn btn-primary ms-2"
                (click)="validate()"
              >
                Validate
              </button>
              <!--SUPPLIER: SUBMIT BUTTON -->
              @if (!isParentShared) {
                <button
                  type="button"
                  class="btn btn-primary ms-2"
                  [disabled]="!enableSubmitButton"
                  (click)="submitConfirm()"
                >
                  Submit
                </button>
              }
            }
          }
          <!-- BUTTONS FOR NON-SUBMITTER QUESTION -->
          @if (!renderSubmitterPreview) {
            <div class="d-flex flex-column align-items-end justify-content-end">
              <!-- PREV NEXT NAVIGATION BUTTONS -->
              <div
                class="d-flex flex-row align-items-center justify-content-end"
              >
                <button
                  type="button"
                  class="btn btn-outline-primary ms-2"
                  (click)="goToPreviousNode()"
                  [disabled]="disablePreviousButton"
                >
                  Previous
                </button>
                @if (!currentlyPreviewedQuestion?.isLastNonSubmitterItem) {
                  <button
                    type="button"
                    class="btn btn-outline-primary ms-2"
                    (click)="goToNextNode(currentlyPreviewedQuestion)"
                    [disabled]="disableNextButton"
                  >
                    Next
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<!-- Modals -->
<app-scores-analysis></app-scores-analysis>
<app-submit-survey-confirmation></app-submit-survey-confirmation>

@if (toggleJsonStructure) {
  <code class="row m-1 max-vw-100 justify-content-center">
    <!-- <pre>{{ dataToPreview | json }}</pre> -->
    <pre>{{ renderPreviewData | json }}</pre>
  </code>
}
